import { apiInterfaceForJson } from '../common/apiManager';

// Pick lists from Administration -> Lookup Lists (read-only, any logged-in user). Cached per session.
const cache = {};
const stamp = {};
const TTL_MS = 60000;
export const getLookup = (listName) => {
    if (cache[listName] && Date.now() - (stamp[listName] || 0) > TTL_MS) delete cache[listName];
    if (!cache[listName]) {
        stamp[listName] = Date.now();
        cache[listName] = apiInterfaceForJson(`/labHub/v1/read/${listName}`, 'GET', null)
            .then((res) => (res && res.data) || [])
            .catch(() => { delete cache[listName]; return []; });
    }
    return cache[listName];
};
export const clearLookupCache = (listName) => {
    if (listName) delete cache[listName];
    else Object.keys(cache).forEach((k) => delete cache[k]);
};
